import "./drawer.css";

import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { useEffect } from "react";

// Shared side-drawer shell (backdrop + header + scrollable body + footer),
// styled after the CLOV-705 user drawer but namespaced (`cf-drawer`) so it can
// back any form. Closes on Escape and backdrop click.
export const Drawer = ({ isOpen, title, onClose, footer, wide, children }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Rendered into <body>: a `filter` or `backdrop-filter` on any ancestor makes
  // that ancestor the containing block of its fixed descendants, which pins the
  // drawer inside it instead of the viewport (the map HUD card blurs its
  // backdrop, and clips it on top of that).
  return createPortal(
    <>
      <div className="cf-drawer__backdrop" onClick={onClose} />
      <div
        className={"cf-drawer" + (wide ? " cf-drawer--wide" : "")}
        role="dialog"
        aria-label={typeof title === "string" ? title : undefined}
      >
        <div className="cf-drawer__header">
          <span>{title}</span>
          <button
            type="button"
            className="cf-drawer__close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="cf-drawer__body">{children}</div>
        {footer && <div className="cf-drawer__footer">{footer}</div>}
      </div>
    </>,
    document.body
  );
};

Drawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  footer: PropTypes.node,
  wide: PropTypes.bool,
  children: PropTypes.node,
};
